import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { TierPage } from './tier.page';

const routes: Routes = [
  {
    path: '',
    component: TierPage
  },
  {
    path: 'tier-form',
    loadChildren: () => import('./tier-form/tier-form.module').then( m => m.TierFormPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TierPageRoutingModule {}
